<template>
    <div id="pageTable">
        <v-overlay :value="loadingLottie"  :z-index="999" >
            <div class="align-center justify-center text-center">
                <v-progress-circular
                    indeterminate
                    :size="100"
                    :width="7"
                    color="#2DB9D1"
                >
                    <v-img
                        src="/static/icon/favicon.ico"
                        :width="60"
                    ></v-img>
                </v-progress-circular>
                <p class="mt-5">{{fraseLoading}}</p>
            </div>
        </v-overlay>    
        <v-container xl fluid>
            <v-row>
                <v-col cols="12" xs="12" sm="12" md="12" class="mx-0 px-0">
                    <v-breadcrumbs :items="itemsLinks">
                        <template v-slot:divider>
                            <v-icon>chevron_right</v-icon>
                        </template>
                    </v-breadcrumbs>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12">
                    <simple-table
                        ref="tablageneral"
                        :tableName="tipoDetalle"
                        :columns="columns"
                        :perPage="[10,25,50,100]"
                        :isSelectable="true"
                        @selectAllEvent="selectAll"
                        :rows="itemsEmpleadosTabla"
                        :loading="isLoading"
                        :valCheck="'empleado_id'"
                    >
                        <template slot="actionButtonsLeft">
                            <v-menu buttom rounded offset-y content-class="menuClassAcciones" class="elevation-0 d-inline ml-2"> 
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="white"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="!masivo"
                                        rounded
                                        class="btn-agrupar-por justify-space-between elevation-0 mr-2 pr-2"
                                    >
                                        Acciones
                                        <v-icon>keyboard_arrow_down</v-icon>
                                    </v-btn>
                                </template>

                                <v-list class="py-0">
                                    <v-list-item
                                        class="py-0 px-8"
                                        @click="recalcular(null, 'empleados')"
                                    >   
                                        <v-list-item-title>Recalcular nómina</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        class="py-0 px-8"
                                        @click="eliminar(null, 'empleados')"
                                    >   
                                        <v-list-item-title>Eliminar nómina</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.empleado_id" v-for="item in data">
                                <td style="width:115px !important; ">
                                    <div >
                                        <v-checkbox class="mb-5" primary hide-details :value="item.empleado_id" v-model="selected_general" ></v-checkbox>
                                    </div>
                                </td>
                                <td><div>{{item.empleado.nombre_completo}}</div></td>
                                <td><div>{{formatoMoneda(item.total_percepciones)}}</div></td>
                                <td><div>{{formatoMoneda(item.total_deducciones)}}</div></td>
                                <td><div>{{formatoMoneda(item.neto_pagar)}}</div></td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" @click="consultar(item)"  class="botonHover" icon fab dark small>
                                                    <v-icon class="tamIconoBoton iconoDelgadoBoton" v-text="'$remove_red_eye_outline'"></v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Ver</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" class="botonHover" icon fab dark small @click="recalcular(item, 'empleado')">
                                                    <v-icon class="tamIconoBoton iconoDelgadoBoton">redo</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Recalcular</span>
                                        </v-tooltip> 
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" class="botonHover" icon fab dark small @click="eliminar(item, 'empleado')">
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </simple-table>
                </v-col>
            </v-row>
        </v-container>
        <template class="borde-card">
            <v-dialog v-model="dialogCalculoTabla" persistent :max-width="tamModal" scrollable class="borde-card">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModalCalculoTabla"></v-btn>
                </template>
                
                    <v-card class="borde-card">
                        <perfect-scrollbar>
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <img :src="imagenCalculoTabla" class="imgModal" />
                                    <h2 class="titleModal">{{ tituloModalCalculoTabla }}</h2>
                                </div>
                            </v-card-title>

                            <v-card-text >
                                <div id="padre" v-show="isLoadingCalculoTabla">
                                    <div id="loading">
                                        <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                    </div>
                                </div>
                                
                                <v-container v-show="!isLoadingCalculoTabla" grid-list-md id="contenedor">
                                    <v-row class="pa-0 ma-0"> 
                                        <simple-table
                                            class="tablaWidth"
                                            :rows="itemsEmpleados"
                                            :columns="headersTableEmpleados"
                                            :perPage="[10, 25, 50, 100]"
                                            shortPagination
                                            :showPagination="false"
                                            :modalTable="true"
                                        >
                                            <tbody class="tbl-incidencias" slot="body" slot-scope="{ data }">
                                                <tr :key="item.id" v-for="(item, index) in data">
                                                    <td class="pa-0">
                                                        <expandable-item :image="urlAvatar + item.empleado.foto" :title="item.empleado.nombre_completo" :id="item.empleado.id" :valid="item.nomina_valida" :type="showDatos" @descargar="descargarCartaFiniquito">
                                                            <template slot="content">
                                                                <table class="tbl-child" width="100%">
                                                                    <tbody>
                                                                        <template v-if="nomina.tipo_periodo_especial === 'AGUINALDO'">
                                                                            <tr>
                                                                                <td><p class="subtitle">Fecha alta IMSS: </p></td>
                                                                                <td><p class="text">{{formatoFecha(item.empleado.fecha_alta_imss)}}</p></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><p class="subtitle">Faltas: </p></td>
                                                                                <td><p class="text">{{item.faltas}}</p></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><p class="subtitle">Incapacidades: </p></td>
                                                                                <td><p class="text">{{item.incapacidades}}</p></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><p class="subtitle">Antiguedad en el año: </p></td>
                                                                                <td><p class="text">{{item.antiguedad_anio}}</p></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><p class="subtitle">Días de aguinaldo pagado: </p></td>
                                                                                <td><p class="text">{{item.dias_aguinaldo}}</p></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><p class="subtitle">Sueldo diario: </p></td>
                                                                                <td><p class="text">{{formatNum(item.empleado.salario_diario)}}</p></td>
                                                                            </tr>
                                                                            <template v-if="item.itemsPercepciones.length != 0">
                                                                                <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                <tr>
                                                                                    <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Percepciones</td>
                                                                                    <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Cantidad</td>
                                                                                </tr>
                                                                                <tr v-for="itemIn in item.itemsPercepciones" :key="itemIn.id">
                                                                                    <td><p class="subtitle">{{itemIn.nombre}}</p></td>
                                                                                    <td><p class="text">{{formatNum(itemIn.total)}}</p></td>
                                                                                </tr>
                                                                                <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                            </template>

                                                                            <template v-if="item.itemsDeducciones.length != 0">
                                                                                <tr v-if="item.itemsPercepciones.length == 0"><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                <tr>
                                                                                    <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Deducciones:</td>
                                                                                    <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;" v-if="item.itemsPercepciones.length == 0">Cantidad</td>
                                                                                </tr>
                                                                                <tr v-for="itemIn in item.itemsDeducciones" :key="itemIn.id">
                                                                                    <td><p class="subtitle">{{itemIn.nombre}}</p></td>
                                                                                    <td><p class="text">{{formatNum(itemIn.total)}}</p></td>
                                                                                </tr>
                                                                                <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                            </template>

                                                                            <template v-if="item.itemsOtrosPagos.length != 0">
                                                                                <tr v-if="item.itemsDeducciones.length == 0"><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                <tr>
                                                                                    <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Otros pagos:</td>
                                                                                    <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;" v-if="item.itemsPercepciones.length == 0 && item.itemsDeducciones.length == 0">Cantidad</td>
                                                                                </tr>
                                                                                <tr v-for="itemIn in item.itemsOtrosPagos" :key="itemIn.id">
                                                                                    <td><p class="subtitle">{{itemIn.nombre}}</p></td>
                                                                                    <td><p class="text">{{formatNum(itemIn.total)}}</p></td>
                                                                                </tr>
                                                                                <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                            </template>

                                                                            <tr>
                                                                                <td><p class="subtitle">Total percepciones: </p></td>
                                                                                <td><p class="text">{{formatNum(item.total_percepciones)}}</p></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><p class="subtitle">Total deducciones: </p></td>
                                                                                <td><p class="text">{{formatNum(item.total_deducciones)}}</p></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><p class="subtitle">Percepciones exentas: </p></td>
                                                                                <td><p class="text">{{formatNum(item.per_exento)}}</p></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><p class="subtitle">Percepciones gravadas: </p></td>
                                                                                <td><p class="text">{{formatNum(item.per_gravado)}}</p></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="py-4" style="color: #1E2245; font-weight: bold;">Neto a recibir: </td>
                                                                                <td class="py-4" style="color: #1E2245; font-weight: bold;">{{formatNum(item.aguinaldo_neto)}}</td>
                                                                            </tr>
                                                                        </template>
                                                                        <template v-if="nomina.tipo_periodo_especial === 'FINIQUITO'">
                                                                            <tr v-if="item.indemnizacion != null">
                                                                                <td style="width: 50%; border-right:1px solid #EFF1FB; vertical-align: top; padding-left:0px !important">
                                                                                    <table>
                                                                                        <tr>
                                                                                            <td class="pb-2 pt-4" style="color: #1E2245; font-weight: bold; font-size: 14px;">Finiquito</td>
                                                                                        </tr>
                                                                                        <tr><td colspan="2"><v-divider class="my-2" style="border: 1px solid #EFF1FB; width:100%"></v-divider></td></tr>

                                                                                        <tr>
                                                                                            <td><p class="subtitle">Fecha alta IMSS: </p></td>
                                                                                            <td><p class="text">{{formatoFecha(item.empleado.fecha_alta_imss)}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Fecha de baja: </p></td>
                                                                                            <td>
                                                                                                <p class="text" v-if="item.empleado.fecha_baja">{{ formatoFecha(item.empleado.fecha_baja)}}</p>
                                                                                                <p class="text" v-else>{{formatoFecha(item.periodo.fecha_baja)}}</p>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr v-if="item.empleado.dias_de_pago != 0">
                                                                                            <td><p class="subtitle">Días de pago: </p></td>
                                                                                            <td><p class="text">{{item.empleado.dias_de_pago}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Sueldo diario: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.empleado.salario_diario)}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Días de aguinaldo: </p></td>
                                                                                            <td><p class="text">{{ item.empleado.dias_aguinaldo_finiquito}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Días de vacaciones: </p></td>
                                                                                            <td><p class="text">{{ item.empleado.dias_vacaciones_finiquito}}</p></td>
                                                                                        </tr>
                                                                                        <tr v-if="item.empleado.dias_de_pago != 0">
                                                                                            <td><p class="subtitle">Faltas: </p></td>
                                                                                            <td><p class="text">{{item.empleado.faltas}}</p></td>
                                                                                        </tr>
                                                                                        <tr v-if="item.empleado.dias_de_pago != 0">
                                                                                            <td><p class="subtitle">Incapacidades: </p></td>
                                                                                            <td><p class="text">{{item.empleado.incapacidades}}</p></td>
                                                                                        </tr>

                                                                                        <template v-if="item.itemsPercepciones.length != 0">
                                                                                            <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                            <tr>
                                                                                                <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Percepciones</td>
                                                                                                <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Cantidad</td>
                                                                                            </tr>
                                                                                            <tr v-for="itemIn in item.itemsPercepciones" :key="itemIn.id">
                                                                                                <td><p class="subtitle">{{itemIn.nombre}}</p></td>
                                                                                                <td><p class="text">{{formatNum(itemIn.total)}}</p></td>
                                                                                            </tr>
                                                                                            <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                        </template>

                                                                                        <template v-if="item.itemsDeducciones.length != 0">
                                                                                            <tr v-if="item.itemsPercepciones.length == 0"><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                            <tr>
                                                                                                <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Deducciones:</td>
                                                                                                <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;" v-if="item.itemsPercepciones.length == 0">Cantidad</td>
                                                                                            </tr>
                                                                                            <tr v-for="itemIn in item.itemsDeducciones" :key="itemIn.id">
                                                                                                <td><p class="subtitle">{{itemIn.nombre}}</p></td>
                                                                                                <td><p class="text">{{formatNum(itemIn.total)}}</p></td>
                                                                                            </tr>
                                                                                            <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                        </template>

                                                                                        <template v-if="item.itemsOtrosPagos.length != 0">
                                                                                            <tr v-if="item.itemsDeducciones.length == 0"><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                            <tr>
                                                                                                <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Otros pagos:</td>
                                                                                                <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;" v-if="item.itemsPercepciones.length == 0 && item.itemsDeducciones.length == 0">Cantidad</td>
                                                                                            </tr>
                                                                                            <tr v-for="itemIn in item.itemsOtrosPagos" :key="itemIn.id">
                                                                                                <td><p class="subtitle">{{itemIn.nombre}}</p></td>
                                                                                                <td><p class="text">{{formatNum(itemIn.total)}}</p></td>
                                                                                            </tr>
                                                                                            <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                        </template>

                                                                                        <tr>
                                                                                            <td><p class="subtitle">Total Percepciones: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.total_percepciones)}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Total deducciones: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.total_deducciones)}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Percepciones exentas: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.per_excentas)}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Percepciones gravadas: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.per_grabado)}}</p></td>
                                                                                        </tr>

                                                                                        <tr>
                                                                                            <td style="color: #1E2245; font-weight: 600; font-size: 13px;">Total neto: </td>
                                                                                            <td style="color: #1E2245; font-weight: 600; font-size: 13px;">{{formatNum(item.neto_pagar)}}</td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </td>

                                                                                <td align="left" style="width: 50%; vertical-align: top;">
                                                                                    <table>
                                                                                        <tr>
                                                                                            <td class="pb-2 pt-4" style="color: #1E2245; font-weight: bold; font-size: 14px;">Indemnización</td>
                                                                                        </tr>
                                                                                        <tr><td colspan="2"><v-divider class="my-2" style="border: 1px solid #EFF1FB; width:100%"></v-divider></td></tr>
                                                                                        
                                                                                        <tr>
                                                                                            <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Información</td>
                                                                                            <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Cantidad</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Días: </p></td>
                                                                                            <td><p class="text">{{item.indemnizacion.dias?item.indemnizacion.dias:'N/A'}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Tipo: </p></td>
                                                                                            <td><p class="text">{{item.indemnizacion.tipo_finiquito?item.indemnizacion.tipo_finiquito:'N/A'}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Años de servicio: </p></td>
                                                                                            <td><p class="text">{{item.indemnizacion.anos_servicio}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Último sueldo mensual ordinario: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.indemnizacion.ultimo_sueldo_mensual_ordinario)}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Salario diario integrado: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.empleado.sueldo_diario_integrado)}}</p></td>
                                                                                        </tr>                                                                                        

                                                                                        <template v-if="item.itemsPercepcionesIndemnizacion.length != 0">
                                                                                            <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                            <tr>
                                                                                                <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Percepciones</td>
                                                                                            </tr>
                                                                                            <tr v-for="itemIndemnizacion in item.itemsPercepcionesIndemnizacion" :key="itemIndemnizacion.id">
                                                                                                <td><p class="subtitle">{{itemIndemnizacion.nombre}}</p></td>
                                                                                                <td><p class="text">{{formatNum(itemIndemnizacion.total)}}</p></td>
                                                                                            </tr>
                                                                                            <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                        </template>
                                                                                        
                                                                                        <!-- <tr v-if="item.p_Indemnizacion != 0">
                                                                                            <td><p class="subtitle">Indemnización: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.p_Indemnizacion)}}</p></td>
                                                                                        </tr>
                                                                                        <tr v-if="item.p_PrimaAntiguedad != 0">
                                                                                            <td><p class="subtitle">Prima de antigüedad: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.p_PrimaAntiguedad)}}</p></td>
                                                                                        </tr>
                                                                                        <tr v-if="item.p_IndemnizacionServicio != 0">
                                                                                            <td><p class="subtitle">Indemnización por año de servicio: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.p_IndemnizacionServicio)}}</p></td>
                                                                                        </tr> -->

                                                                                        
                                                                                        <template v-if="item.itemsDeduccionesIndemnizacion.length != 0">
                                                                                            <tr v-if="item.itemsPercepcionesIndemnizacion.length == 0"><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                            <tr>
                                                                                                <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Deducciones</td>
                                                                                            </tr>
                                                                                            <tr v-for="itemIndemnizacion in item.itemsDeduccionesIndemnizacion" :key="itemIndemnizacion.id">
                                                                                                <td><p class="subtitle">{{itemIndemnizacion.nombre}}</p></td>
                                                                                                <td><p class="text">{{formatNum(itemIndemnizacion.total)}}</p></td>
                                                                                            </tr>
                                                                                            <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                        </template>
                                                                                        
                                                                                        <!-- <tr>
                                                                                            <td><p class="subtitle">ISR Indemnización: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.indemnizacion.total_isr)}}</p></td>
                                                                                        </tr> -->

                                                                                        <template v-if="item.itemsOtrosPagosIndemnizacion.length != 0">
                                                                                            <tr v-if="item.itemsDeduccionesIndemnizacion.length == 0"><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%"></v-divider></td></tr>
                                                                                            <tr>
                                                                                                <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Otros pagos:</td>
                                                                                                <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;" v-if="item.itemsPercepcionesIndemnizacion.length == 0 && item.itemsDeduccionesIndemnizacion.length == 0">Cantidad</td>
                                                                                            </tr>
                                                                                            <tr v-for="itemIndemnizacion in item.itemsOtrosPagosIndemnizacion" :key="itemIndemnizacion.id">
                                                                                                <td><p class="subtitle">{{itemIndemnizacion.nombre}}</p></td>
                                                                                                <td><p class="text">{{formatNum(itemIndemnizacion.total)}}</p></td>
                                                                                            </tr>
                                                                                            <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr>
                                                                                        </template>

                                                                                        <tr>
                                                                                            <td><p class="subtitle">Total Percepciones: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.indemnizacion.total_percepciones)}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Total deducciones: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.indemnizacion.total_deducciones)}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Percepciones exentas: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.indemnizacion.per_exento)}}</p></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td><p class="subtitle">Percepciones gravadas: </p></td>
                                                                                            <td><p class="text">{{formatNum(item.indemnizacion.per_gravado)}}</p></td>
                                                                                        </tr>

                                                                                        <tr>
                                                                                            <td style="color: #1E2245; font-weight: 600; font-size: 13px;">Total neto: </td>
                                                                                            <td style="color: #1E2245; font-weight: 600; font-size: 13px;">{{formatNum(item.indemnizacion.total_neto)}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td style="color: #1E2245; font-weight: 600; font-size: 13px;">Neto a pagar: </td>
                                                                                            <td style="color: #1E2245; font-weight: 600; font-size: 13px;"> {{netoPago(item.neto_pagar,item.indemnizacion.total_neto)}}</td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </td>
                                                                            </tr>

                                                                            <template v-else>
                                                                                <tr>
                                                                                    <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Información</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td><p class="subtitle">Fecha alta IMSS: </p></td>
                                                                                    <td><p class="text">{{formatoFecha(item.empleado.fecha_alta_imss)}}</p></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td><p class="subtitle">Fecha de baja: </p></td>
                                                                                    <td>
                                                                                        <p class="text" v-if="item.empleado.fecha_baja">{{ formatoFecha(item.empleado.fecha_baja)}}</p>
                                                                                        <p class="text" v-else>{{formatoFecha(item.periodo.fecha_baja)}}</p>
                                                                                    </td>
                                                                                </tr>
                                                                                <tr v-if="item.empleado.dias_de_pago != 0">
                                                                                    <td><p class="subtitle">Días de pago: </p></td>
                                                                                    <td><p class="text">{{item.empleado.dias_de_pago}}</p></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td><p class="subtitle">Sueldo diario: </p></td>
                                                                                    <td><p class="text">{{formatNum(item.empleado.salario_diario)}}</p></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td><p class="subtitle">Días de aguinaldo: </p></td>
                                                                                    <td><p class="text">{{ item.empleado.dias_aguinaldo_finiquito}}</p></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td><p class="subtitle">Días de vacaciones: </p></td>
                                                                                    <td><p class="text">{{ item.empleado.dias_vacaciones_finiquito}}</p></td>
                                                                                </tr>
                                                                                <tr v-if="item.empleado.dias_de_pago != 0">
                                                                                    <td><p class="subtitle">Faltas: </p></td>
                                                                                    <td><p class="text">{{item.empleado.faltas}}</p></td>
                                                                                </tr>
                                                                                <tr v-if="item.empleado.dias_de_pago != 0">
                                                                                    <td><p class="subtitle">Incapacidades: </p></td>
                                                                                    <td><p class="text">{{item.empleado.incapacidades}}</p></td>
                                                                                </tr>

                                                                                <template v-if="item.itemsPercepciones.length != 0">
                                                                                    <!-- <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:100%;"></v-divider></td></tr> -->
                                                                                    <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:calc(100% - 35px);"></v-divider></td></tr>
                                                                                    <tr>
                                                                                        <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Percepciones</td>
                                                                                        <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Cantidad</td>
                                                                                    </tr>
                                                                                    <tr v-for="itemIn in item.itemsPercepciones" :key="itemIn.id">
                                                                                        <td><p class="subtitle">{{itemIn.nombre}}</p></td>
                                                                                        <td><p class="text">{{formatNum(itemIn.total)}}</p></td>
                                                                                    </tr>
                                                                                    <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:calc(100% - 35px);"></v-divider></td></tr>
                                                                                </template>

                                                                                <template v-if="item.itemsDeducciones.length != 0">
                                                                                    <tr v-if="item.itemsPercepciones.length == 0"><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:calc(100% - 35px);"></v-divider></td></tr>
                                                                                    <tr>
                                                                                        <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Deducciones:</td>
                                                                                        <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;" v-if="item.itemsPercepciones.length == 0">Cantidad</td>
                                                                                    </tr>
                                                                                    <tr v-for="itemIn in item.itemsDeducciones" :key="itemIn.id">
                                                                                        <td><p class="subtitle">{{itemIn.nombre}}</p></td>
                                                                                        <td><p class="text">{{formatNum(itemIn.total)}}</p></td>
                                                                                    </tr>
                                                                                    <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:calc(100% - 35px);"></v-divider></td></tr>
                                                                                </template>

                                                                                <template v-if="item.itemsOtrosPagos.length != 0">
                                                                                    <tr v-if="item.itemsDeducciones.length == 0"><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:calc(100% - 35px);"></v-divider></td></tr>
                                                                                    <tr>
                                                                                        <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;">Otros pagos:</td>
                                                                                        <td class="pb-2 pt-1" style="color:#444975; font-weight:600; font-size:14px;" v-if="item.itemsPercepciones.length == 0 && item.itemsDeducciones.length == 0">Cantidad</td>
                                                                                    </tr>
                                                                                    <tr v-for="itemIn in item.itemsOtrosPagos" :key="itemIn.id">
                                                                                        <td><p class="subtitle">{{itemIn.nombre}}</p></td>
                                                                                        <td><p class="text">{{formatNum(itemIn.total)}}</p></td>
                                                                                    </tr>
                                                                                    <tr><td colspan="2"><v-divider class="my-4" style="border: 1px solid #EFF1FB; width:calc(100% - 35px);"></v-divider></td></tr>
                                                                                </template>

                                                                                <tr>
                                                                                    <td><p class="subtitle">Total Percepciones: </p></td>
                                                                                    <td><p class="text">{{formatNum(item.total_percepciones)}}</p></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td><p class="subtitle">Total deducciones: </p></td>
                                                                                    <td><p class="text">{{formatNum(item.total_deducciones)}}</p></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td><p class="subtitle">Total otros pagos: </p></td>
                                                                                    <td><p class="text">{{formatNum(item.otros_ingresos)}}</p></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td><p class="subtitle">Percepciones exentas: </p></td>
                                                                                    <td><p class="text">{{formatNum(item.per_excentas)}}</p></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td><p class="subtitle">Percepciones gravadas: </p></td>
                                                                                    <td><p class="text">{{formatNum(item.per_grabado)}}</p></td>
                                                                                </tr>

                                                                                <tr class="mb-4 pb-4" style="">
                                                                                    <td style="color: #1E2245; font-weight: bold; font-size: 13px; padding-bottom:16px; padding-top:16px;">Neto a pagar: </td>
                                                                                    <td style="color: #1E2245; font-weight: bold; font-size: 13px; padding-bottom:16px; padding-top:16px;">{{formatNum(item.neto_pagar)}}</td>
                                                                                </tr>
                                                                            </template>
                                                                        </template>
                                                                    </tbody>
                                                                </table>
                                                            </template>
                                                        </expandable-item>

                                                        <hr v-if="index < data.length - 1" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </simple-table>
                                    </v-row>  
                                </v-container>
                            </v-card-text>
                        </perfect-scrollbar>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button 
                                class="btnCerrar" 
                                @click="cerrarModalTabla()"
                            >
                                Cerrar
                            </button>        
                        </v-card-actions>
                    </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Vue from 'vue';
import Datatable from '@/components/datatable/Datatable.vue';
import DatatableSimple from '@/components/simpletable/Datatable.vue';
import ExpandableItem from '@/components/ExpandableItem.vue';
import Notify from '@/plugins/notify';
import apiCalculoNomina from '@/api/nominas/calculoNomina';
import GetUrlImg from "@/plugins/Urlimagen";

export default {
    components: {
        'data-table': Datatable,
        "simple-table": DatatableSimple,
        ExpandableItem,
    },
    data() {
        return {
            url         : "nominas-timbres/detalle",
            columns     : [
                {
                    label: 'Empleado',
                    name: 'nombre_completo',
                    filterable: false
                },
                {
                    label: 'Total percepciones',
                    name: 'total_percepciones',
                    filterable: false
                },
                {
                    label: 'Total deducciones',
                    name: 'total_deducciones',
                    filterable: false
                },
                {
                    label: 'Neto a pagar',
                    name: 'neto_pagar',
                    filterable: false
                },
                {
                    label: 'Opciones',
                    name: 'opciones',
                    align: 'center',
                    filterable: false
                }
            ],
            itemsLinks      : [
                {
                    text: 'Aguinaldo/Finiquito',
                    disabled: false,
                    to: 'AguinaldoFiniquito',
                },
                {
                    text: 'Detalle',
                    disabled: true,
                    to: '/detalle'
                },
            ],
            filters     : {
                activo    :true,
                paginate  :true,
                order     :"asc",
                nomina_id : null
            },
            userData                : this.$session.get('usuario'),
            accion                  : null,
            tituloModal             : null,
            dialog                  : false,
            isLoading               : false,
            isSaving                : false,
            imagen                  : "",
            nomina                  : null,
            checkAll                : false,
            selected_general        : [],
            selected_general_tabla  : [],
            unselected_general      : [],
            masivo                  : false,
            masivo_tabla            : false,
            loadingLottie           : false,
            fraseLoading            : 'Timbrando',
            dialogCalculoTabla      : false,
            isLoadingCalculoTabla   : false,
            itemsEmpleados          : [],
            headersTableEmpleados   : [
                { label: "Empleados", align:'center',   name: "nombre_completo",    filterable: false },
            ],
            urlAvatar               : '',
            imagenCalculoTabla      : '/static/icon/consultar-calculo.png',
            tituloModalCalculoTabla : 'Resultados de la consulta',
            itemsEmpleadosTabla     : [],
            showDatos               : null,
            tamModal                : "700px",

        }
    },
    watch:{
        selected_general:function(value) {
            if(value.length > 0 ){
                this.masivo =  true;
            }
            else{
                this.masivo =  false;
            }
        },
    },
    computed: {
        tipoDetalle(){
            return this.nomina.tipo_periodo_especial === 'AGUINALDO'? 'Detalle de precálculo de aguinaldo':'Detalle de precálculo del finiquito'
        }
    },
    methods: {
        abrirModal(accion, data = null) {
            this.accion     = accion;
            this.isLoading  = true;
            this.isLoading  = false;
        },
        cerrarModal() {
            this.dialog     = false;
            this.isSaving   = false;
            this.resetValues();
        },
        resetValues() {
           
            this.$nextTick(() => {
                this.$refs.form.reset();
            });
        },
        guardar() {
            
        },
        eliminar(data, accion){

            let mensaje = '';
            let param = {};
            if(accion === 'empleado'){
                mensaje = "¿Estás seguro que deseas eliminar el empleado "+data.empleado.nombre_completo+"?";
                param = { nomina_id: this.nomina.nomina_id,empleados: [data.empleado_id]}
            }
            else{
                mensaje = "¿Estás seguro que deseas eliminar a los empleados seleccionados?"
                param = { nomina_id: this.nomina.nomina_id,empleados: this.selected_general}
            }

            Notify.Alert(
                "ADVERTENCIA",
                mensaje,
                "Eliminar",
                () => {
                    this.fraseLoading = "Eliminando";
                    this.loadingLottie = true;
                    apiCalculoNomina.eliminarEmpleadoPrecalculo(param).then(async response => {
                        this.loadingLottie=false; 
                        await this.getEmpleados(this.nomina.nomina_id);
                        Notify.Success("Operación exitosa", "La petición se realizo satisfactoriamente.");
                        this.selected_general=[];
                       
                    })
                    .catch(err => {
                        this.loadingLottie=false; 
                        this.selected_general=[];
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }
                            Notify.ErrorToast(leyenda);
                        }
                        this.$refs.tabla.unselectAll();
                    });
                }
            )
        },
        /**
         * @method formatoMoneda Este método sirve para formatear el valor a formato moneda en la tabla principal.
         * @description Este método sirve para formatear el valor a formato moneda en la tabla principal.
         */
        formatoMoneda(value){
            const formatter = new Intl.NumberFormat('es-MX', {
                style: 'currency',
                currency: 'MXN',
            })
            return formatter.format(value)
        },
        /**
         * @method selectAll Este método se realiza al dar clic en el check que esta en el header de la tabla principal.
         * @description Este método se realiza al dar clic en el check que esta en el header de la tabla principal. Se selecciones todos los check o se deseleccionan.
         * Se ejecuta con una emit del componente tabla.
         * @param {boolean} isSelected variable para saber si check se esta seleccionado o no.
         * @param {object} items variable donde vienen todos los items de los empledos.
         */
        selectAll(isSelected, items) {
            this.selected_general = items;
        },

        async recalcular(item, emp){
            let self = this;
            let param = {};
            if(emp === 'empleado'){
                param = { 
                    id : this.nomina.nomina_id, 
                    accion: 'RECALCULAR', 
                    tipo_reporte: "empleados", 
                    tipo_nomina : this.nomina.tipo_periodo_especial, 
                    empleados : [
                        {empleado_id: item.empleado_id}
                    ], 
                    descargar:true,
                    periodo_id: this.nomina.id,
                    tipo_nomina_id: this.nomina.tipo_nomina_id,
                }
            }
            else{
                let empleados = [];
                this.selected_general.forEach((element) => {
                    empleados.push({empleado_id: element});
                });
                param = { 
                    id : this.nomina.nomina_id, 
                    accion: 'RECALCULAR', 
                    tipo_reporte: "empleados", 
                    tipo_nomina : this.nomina.tipo_periodo_especial, 
                    empleados : empleados, 
                    descargar:true,
                    periodo_id: this.nomina.id,
                    tipo_nomina_id: this.nomina.tipo_nomina_id,
                }
            }

            let urlCalculo = "";

            if(this.nomina.tipo_periodo_especial == 'AGUINALDO'){
                urlCalculo = "calculo-nomina/calcular-aguinaldo"
            }
            else if(this.nomina.tipo_periodo_especial == 'FINIQUITO'){
                urlCalculo = "calculo-nomina/calcular-finiquito"
            }
            const FileDownload = require("js-file-download");
            let nombre;
            //nombre = "recalculado.xlsx"
            //nombre =  this.nomina.clave_tipo_nomina + "-" + this.nomina.descripcion + " - Periodo " + this.nomina.numero_periodo + ".xlsx";
            nombre = this.nomina.tipo_periodo_especial+".xlsx"
            this.loadingLottie =  true;
            this.fraseLoading = "Descargando";
            const object1 = param;
            try {
                await Vue.axios({
                    method: "POST",
                    responseType: "blob",
                    url: urlCalculo,
                    data: object1,
                }).then(async function(response){
                    FileDownload(response.data, nombre);
                    await self.getEmpleados(self.nomina.nomina_id);
                    self.selected_general=[];
                    self.$refs.tablageneral.unselectAll();
                    self.loadingLottie =  false;
                })
                .catch(async (error) => {
                    self.$refs.tablageneral.unselectAll();
                    self.selected_general=[];
                    //console.log(decodeURIComponent(escape(error.response.headers["content-type"])));
                    //Notify.ErrorToast(decodeURIComponent(escape(error.response.headers["content-type"])));
                    let errorString = error.response.data;
                    if (
                        error.request.responseType === 'blob' &&
                        error.response.data instanceof Blob &&
                        error.response.data.type &&
                        error.response.data.type.toLowerCase().indexOf('json') != -1
                    ){
                        errorString = JSON.parse(await error.response.data.text());
                        console.log(errorString)

                        if(typeof errorString.error === 'string'){
                            Notify.ErrorToast(errorString.error);
                        }else{
                            let error = Object.values(errorString.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }
                            Notify.ErrorToast(leyenda);
                        }
                    }
                    else{
                        Notify.ErrorToast("Error");
                    }
                    self.loadingLottie =  false;
                });
            } catch (err) {
                self.$refs.tablageneral.unselectAll();
                self.selected_general=[];
                Notify.ErrorToast("No se pudo realizar esta acción");
                self.loadingLottie =  false;
            }
        },

        async consultar(item){
            let self = this;
            if(item == null || item == undefined) {
                return;
            }
            let formatEmpleados = [{"empleado_id":item.empleado_id}];
            this.isLoadingCalculoTabla = true;
            
            let parametros = {};
            
            parametros = {
                "accion":"RECONSULTAR",
                "tipo_reporte": "empleados",
                "tipo_nomina": this.nomina.tipo_periodo_especial,
                "periodo_id": item.periodo.id,
                "tipo_nomina_id": item.nomina.tipo_nomina_id,
                "empleados": formatEmpleados
            }
            
            this.showDatos = item.tipo_periodo_especial;

            if(this.nomina.tipo_periodo_especial == 'AGUINALDO'){
                //this.itemFiniquito = null;
                apiCalculoNomina.calcularAguinaldo(parametros).then((response) => {
                    this.itemsEmpleados = response.data;

                    self.totalEmpleados         = response.data.length;
                    self.totalPercepciones      = response.totales.percepciones;
                    self.totalDeducciones       = response.totales.deducciones;
                    self.neto                   = response.totales.neto;


                    let formatEmpleados = response.data;

                    if(formatEmpleados.length != 0){
                        self.totalEmpleados    = formatEmpleados.length;
                        formatEmpleados.forEach(empleado => {
                            empleado.itemsPercepciones  = [];
                            empleado.itemsDeducciones   = [];
                            empleado.itemsOtrosPagos    = [];
                            empleado.itemsInformativos  = [];
                            empleado.p_IndemnizacionServicio = 0;
                            empleado.p_PrimaAntiguedad  = 0;
                            empleado.p_Indemnizacion    = 0;

                            
                            empleado.incidencias.forEach(incidencia =>{
                                switch (incidencia.codigo_incidencia.charAt(0)) {
                                    case 'P':
                                        if(incidencia.funcion_nombre == "p_IndemnizacionServicio"){
                                            empleado.p_IndemnizacionServicio = incidencia.total;
                                            this.tamModal = "1000px";
                                        }
                                        else if(incidencia.funcion_nombre == "p_PrimaAntiguedad"){
                                            empleado.p_PrimaAntiguedad  = incidencia.total;
                                            this.tamModal = "1000px";
                                        }
                                        else if(incidencia.funcion_nombre == "p_Indemnizacion"){
                                            empleado.p_Indemnizacion    = incidencia.total;
                                            this.tamModal = "1000px";
                                        }
                                        else{
                                            let complemento = {
                                                codigo : incidencia.codigo_incidencia,
                                                nombre : incidencia.nombre_incidencia,
                                                total  : incidencia.total
                                            }
                                            if(parseFloat(incidencia.total) != 0){
                                                empleado.itemsPercepciones.push(complemento);
                                            }
                                        }
                                        break;
                                    case 'D':
                                        let complemento2 = {
                                            codigo : incidencia.codigo_incidencia,
                                            nombre : incidencia.nombre_incidencia,
                                            total  : incidencia.total
                                        }
                                        if(parseFloat(incidencia.total) != 0){
                                            empleado.itemsDeducciones.push(complemento2);
                                        }
                                        break;
                                    case 'O':
                                        let complemento3 = {
                                            codigo : incidencia.codigo_incidencia,
                                            nombre : incidencia.nombre_incidencia,
                                            total  : incidencia.total
                                        }
                                        if(parseFloat(incidencia.total) != 0){
                                            empleado.itemsOtrosPagos.push(complemento3);
                                        }
                                        break;  
                                    case 'I':
                                        let complemento4 = {
                                            codigo : incidencia.codigo_incidencia,
                                            nombre : incidencia.nombre_incidencia,
                                            total  : incidencia.total
                                        }
                                        if(parseFloat(incidencia.total) != 0){
                                            empleado.itemsInformativos.push(complemento4);
                                        }
                                        break;  
                                    default:
                                        break;
                                }  
                            })
                            if(parseFloat(empleado.isr_retener) != 0){
                                empleado.itemsDeducciones.push({
                                    codigo : 'O999',
                                    nombre : 'ISR',
                                    total  : empleado.isr_retener
                                });
                            }
                        })
                    }

                    setTimeout(function(){ document.getElementById("btnModalCalculoTabla").click(); }, 100);
                    this.isLoadingCalculoTabla = false;
                    this.btnConsultar       = false;
                    this.invaliBtnGuardar   = false;
                    this.btnCerrar          = false;
                })
                .catch (err => {
                    console.log(err);
                    if(typeof err.response.data.error === 'string'){
                        Notify.ErrorToast(err.response.data.error);
                    }else{
                        let error = Object.values(err.response.data.error);
                        let leyenda = ``;

                        for (var i = 0; i < error.length; i++) {
                            leyenda+= `* ` + error[i] + `\n`;
                        }

                        Notify.ErrorToast(leyenda);
                    }
                    this.cerrarModalTabla();
                })
            }
            if(this.nomina.tipo_periodo_especial == 'FINIQUITO'){
                //this.itemFiniquito = item;
                apiCalculoNomina.calcularFiniquito(parametros).then((response) => {
                    self.totalPercepciones       = response.totales.percepciones;
                    self.totalDeducciones        = response.totales.deducciones;
                    self.totalOtrosPagos         = response.totales.otros_pagos;
                    self.neto                    = response.totales.neto;

                    let formatEmpleados = response.data;

                    if(formatEmpleados.length != 0){
                        self.totalEmpleados    = formatEmpleados.length;
                        formatEmpleados.forEach(empleado => {
                            empleado.itemsPercepciones  = [];
                            empleado.itemsDeducciones   = [];
                            empleado.itemsOtrosPagos    = [];
                            empleado.itemsInformativos  = [];
                            empleado.p_IndemnizacionServicio = 0;
                            empleado.p_PrimaAntiguedad  = 0;
                            empleado.p_Indemnizacion    = 0;

                            empleado.itemsPercepcionesIndemnizacion     = [];
                            empleado.itemsDeduccionesIndemnizacion      = [];
                            empleado.itemsOtrosPagosIndemnizacion       = [];
                            empleado.itemsInformativosIndemnizacion     = [];


                            if(parseFloat(empleado.empleado.total_sueldo) != 0){
                                empleado.itemsPercepciones.push({
                                    codigo : 'P1000',
                                    nombre : 'Sueldo',
                                    total  : empleado.empleado.total_sueldo
                                });
                            }
                            empleado.incidencias.forEach(incidencia =>{
                                switch (incidencia.codigo_incidencia.charAt(0)) {
                                    case 'P':
                                        if(incidencia.funcion_nombre == "p_IndemnizacionServicio"){
                                            empleado.p_IndemnizacionServicio = incidencia.total;
                                            this.tamModal = "1000px";
                                        }
                                        else if(incidencia.funcion_nombre == "p_PrimaAntiguedad"){
                                            empleado.p_PrimaAntiguedad  = incidencia.total;
                                            this.tamModal = "1000px";
                                        }
                                        else if(incidencia.funcion_nombre == "p_Indemnizacion"){
                                            empleado.p_Indemnizacion    = incidencia.total;
                                            this.tamModal = "1000px";
                                        }
                                        else{
                                            let complemento = {
                                                codigo : incidencia.codigo_incidencia,
                                                nombre : incidencia.nombre_incidencia,
                                                total  : incidencia.total
                                            }
                                            if(parseFloat(incidencia.total) != 0){
                                                empleado.itemsPercepciones.push(complemento);
                                            }
                                        }
                                        break;
                                    case 'D':
                                        let complemento2 = {
                                            codigo : incidencia.codigo_incidencia,
                                            nombre : incidencia.nombre_incidencia,
                                            total  : incidencia.total
                                        }
                                        if(parseFloat(incidencia.total) != 0){
                                            empleado.itemsDeducciones.push(complemento2);
                                        }
                                        break;
                                    case 'O':
                                        let complemento3 = {
                                            codigo : incidencia.codigo_incidencia,
                                            nombre : incidencia.nombre_incidencia,
                                            total  : incidencia.total
                                        }
                                        if(parseFloat(incidencia.total) != 0){
                                            empleado.itemsOtrosPagos.push(complemento3);
                                        }
                                        break;  
                                    case 'I':
                                        let complemento4 = {
                                            codigo : incidencia.codigo_incidencia,
                                            nombre : incidencia.nombre_incidencia,
                                            total  : incidencia.total
                                        }
                                        if(parseFloat(incidencia.total) != 0){
                                            empleado.itemsInformativos.push(complemento4);
                                        }
                                        break;  
                                    default:
                                        break;
                                }  
                            })
                            
                            if(empleado.indemnizacion != null && empleado.indemnizacion.length != 0){
                                this.tamModal = "1000px";

                                console.log(empleado)
                                empleado.indemnizacion.incidencias.forEach(incidenciaIndemnizacion => {

                                    switch (incidenciaIndemnizacion.codigo_incidencia.charAt(0)) {
                                        case 'P':
                                            let complemento = {
                                                codigo : incidenciaIndemnizacion.codigo_incidencia,
                                                nombre : incidenciaIndemnizacion.nombre_incidencia,
                                                total  : incidenciaIndemnizacion.total
                                            }
                                            if(parseFloat(incidenciaIndemnizacion.total) != 0){
                                                empleado.itemsPercepcionesIndemnizacion.push(complemento);
                                            }
                                            break;
                                        case 'D':
                                            let complemento2 = {
                                                codigo : incidenciaIndemnizacion.codigo_incidencia,
                                                nombre : incidenciaIndemnizacion.nombre_incidencia,
                                                total  : incidenciaIndemnizacion.total
                                            }
                                            if(parseFloat(incidenciaIndemnizacion.total) != 0){
                                                empleado.itemsDeduccionesIndemnizacion.push(complemento2);
                                            }
                                            break;
                                        case 'O':
                                            let complemento3 = {
                                                codigo : incidenciaIndemnizacion.codigo_incidencia,
                                                nombre : incidenciaIndemnizacion.nombre_incidencia,
                                                total  : incidenciaIndemnizacion.total
                                            }
                                            if(parseFloat(incidenciaIndemnizacion.total) != 0){
                                                empleado.itemsOtrosPagosIndemnizacion.push(complemento3);
                                            }
                                            break;  
                                        case 'I':
                                            let complemento4 = {
                                                codigo : incidenciaIndemnizacion.codigo_incidencia,
                                                nombre : incidenciaIndemnizacion.nombre_incidencia,
                                                total  : incidenciaIndemnizacion.total
                                            }
                                            if(parseFloat(incidenciaIndemnizacion.total) != 0){
                                                empleado.itemsInformativosIndemnizacion.push(complemento4);
                                            }
                                            break;  
                                        default:
                                            break;
                                    }

                                })
                            }

                            if(parseFloat(empleado.subsidio) != 0){
                                empleado.itemsOtrosPagos.push({
                                    codigo : 'O999',
                                    nombre : 'Subsidio',
                                    total  : empleado.subsidio
                                });
                            }
                            if(parseFloat(empleado.isr) != 0){
                                empleado.itemsDeducciones.push({
                                    codigo : 'D998',
                                    nombre : 'ISR',
                                    total  : empleado.isr
                                });
                            }
                            if(parseFloat(empleado.imss) != 0){
                                empleado.itemsDeducciones.push({
                                    codigo : 'D999',
                                    nombre : 'IMSS',
                                    total  : empleado.imss
                                });
                            }
                        })
                    }



                    this.itemsEmpleados = formatEmpleados;

                    setTimeout(function(){ document.getElementById("btnModalCalculoTabla").click(); }, 100);
                    this.isLoadingCalculoTabla = false;
                    this.btnConsultar       = false;
                    this.invaliBtnGuardar   = false;
                    this.btnCerrar          = false;
                })
                .catch (err => {
                    console.log(err);
                    if(typeof err.response.data.error === 'string'){
                        Notify.ErrorToast(err.response.data.error);
                    }else{
                        let error = Object.values(err.response.data.error);
                        let leyenda = ``;

                        for (var i = 0; i < error.length; i++) {
                            leyenda+= `* ` + error[i] + `\n`;
                        }

                        Notify.ErrorToast(leyenda);
                    }
                    this.cerrarModalTabla();
                })
            }
        },
        async descargarCartaFiniquito(empleados) {
            return;
            let parametros = {
                    "accion":"RECONSULTAR",
                    "tipo_reporte": "empleados",
                    "tipo_nomina": "FINIQUITO",
                    "periodo_id": this.itemFiniquito.id,
                    "tipo_nomina_id": this.itemFiniquito.tipo_nomina_id,
                    "empleados": empleados
                }
           

            let urlCalculo = "calculo-nomina/calcular-finiquito/descargar";
            
            
            const FileDownload = require("js-file-download"); 
            let nombre;
            nombre = this.itemFiniquito.empresa + "-" + this.itemFiniquito.tipo_nomina + "-" + this.itemFiniquito.numero + ".pdf";
            this.fraseLoading = "Descargando";
            this.loadingLottie = true;
            try {
                Vue.axios({
                method: "POST",
                responseType: "blob",
                url: urlCalculo,
                data: parametros,
                }).then((response, status, xhr) => {
                    FileDownload(response.data, nombre);
                    if(this.aguinaldoFiniquito.nomina_id == 0){
                        this.$refs.tablaDatos.getData();
                    }
                    this.cerrarModal();
                    this.btnGuardar             = false;
                    this.invalidBtnConsultar    = false;
                    this.btnCerrar              = false; 
                    this.dialogDownload         = false;
                    this.loadingLottie          = false;
                })
                .catch(err =>{
                    console.log(err);
                    this.btnGuardar             = false;
                    this.invalidBtnConsultar    = false;
                    this.btnCerrar              = false; 
                    this.dialogDownload         = false;
                    this.loadingLottie          = false;
                });
            } 
            catch (err) {
                Notify.ErrorToast("No se pudo realizar el cálculo");
                console.log(err);
                this.btnGuardar             = false;
                this.invalidBtnConsultar    = false;
                this.btnCerrar              = false;
                this.dialogDownload         = false;
                this.loadingLottie          = false;
                this.cerrarModal();
                this.$refs.tablaDatos.getData();
            }
        },



        async consultarPrecalculo(empleado){
            let self = this;
            this.isLoadingCalculoTabla = true;
            setTimeout(function(){ document.getElementById("btnModalCalculoTabla").click(); }, 100);
            let empleados = [{empleado_id: empleado.empleado_id}];
          
            let tipoConsulta = 'RECONSULTAR';
            let parametros = { id : this.nomina.nomina_id, accion: tipoConsulta, tipo_reporte: "empleados", tipo_nomina : 'GENERAL', empleados : empleados }
            await apiCalculoNomina.calcular(parametros).then((response) => {
                let formatEmpleados = response.data;

                if(formatEmpleados.length != 0){
                    self.totalEmpleados    = formatEmpleados.length;
                    formatEmpleados.forEach(empleado => {
                        empleado.itemsPercepciones  = [];
                        empleado.itemsDeducciones   = [];
                        empleado.itemsOtrosPagos    = [];
                        empleado.itemsInformativos  = [];

                        if(parseFloat(empleado.empleado.total_sueldo) != 0){
                            empleado.itemsPercepciones.push({
                                codigo : 'P1000',
                                nombre : 'Sueldo',
                                total  : empleado.empleado.total_sueldo
                            });
                        }
                        empleado.incidencias.forEach(incidencia =>{
                            switch (incidencia.codigo_incidencia.charAt(0)) {
                                case 'P':
                                    let complemento = {
                                        codigo : incidencia.codigo_incidencia,
                                        nombre : incidencia.nombre_incidencia,
                                        total  : incidencia.total
                                    }
                                    if(parseFloat(incidencia.total) != 0){
                                        empleado.itemsPercepciones.push(complemento);
                                    }
                                    
                                    break;
                                case 'D':
                                    let complemento2 = {
                                        codigo : incidencia.codigo_incidencia,
                                        nombre : incidencia.nombre_incidencia,
                                        total  : incidencia.total
                                    }
                                    if(parseFloat(incidencia.total) != 0){
                                        empleado.itemsDeducciones.push(complemento2);
                                    }
                                    break;
                                case 'O':
                                    let complemento3 = {
                                        codigo : incidencia.codigo_incidencia,
                                        nombre : incidencia.nombre_incidencia,
                                        total  : incidencia.total
                                    }
                                    if(parseFloat(incidencia.total) != 0){
                                        empleado.itemsOtrosPagos.push(complemento3);
                                    }
                                    break;  
                                case 'I':
                                    let complemento4 = {
                                        codigo : incidencia.codigo_incidencia,
                                        nombre : incidencia.nombre_incidencia,
                                        total  : incidencia.total
                                    }
                                    if(parseFloat(incidencia.total) != 0){
                                        empleado.itemsInformativos.push(complemento4);
                                    }
                                    break;  
                                default:
                                    break;
                            }  
                        })

                        if(empleado.ajuste_mensual){
                            empleado.ajuste_mensual.forEach(incidencia =>{
                                switch (incidencia.codigo.charAt(0)) {
                                    case 'P':
                                        let complemento = {
                                            codigo : incidencia.codigo,
                                            nombre : incidencia.nombre,
                                            total  : incidencia.total
                                        }
                                        if(parseFloat(incidencia.total) != 0){
                                            empleado.itemsPercepciones.push(complemento);
                                        }
                                        break;
                                    case 'D':
                                        let complemento2 = {
                                            codigo : incidencia.codigo,
                                            nombre : incidencia.nombre,
                                            total  : incidencia.total
                                        }
                                        if(parseFloat(incidencia.total) != 0){
                                            empleado.itemsDeducciones.push(complemento2);
                                        }
                                        break;
                                    case 'O':
                                        let complemento3 = {
                                            codigo : incidencia.codigo,
                                            nombre : incidencia.nombre,
                                            total  : incidencia.total
                                        }
                                        if(parseFloat(incidencia.total) != 0){
                                            empleado.itemsOtrosPagos.push(complemento3);
                                        }
                                        break;  
                                    case 'I':
                                        let complemento4 = {
                                            codigo : incidencia.codigo,
                                            nombre : incidencia.nombre,
                                            total  : incidencia.total
                                        }
                                        if(parseFloat(incidencia.total) != 0){
                                            empleado.itemsInformativos.push(complemento4);
                                        }
                                        break;  
                                    default:
                                        break;
                                }  
                            })
                        }
                        

                        if(parseFloat(empleado.subsidio) != 0){
                            empleado.itemsOtrosPagos.push({
                                codigo : 'O999',
                                nombre : 'Subsidio',
                                total  : empleado.subsidio
                            });
                        }
                        if(parseFloat(empleado.isr) != 0){
                            empleado.itemsDeducciones.push({
                                codigo : 'D998',
                                nombre : 'ISR',
                                total  : empleado.isr
                            });
                        }
                        if(parseFloat(empleado.imss) != 0){
                            empleado.itemsDeducciones.push({
                                codigo : 'D999',
                                nombre : 'IMSS',
                                total  : empleado.imss
                            });
                        }
                    })
                }

                this.itemsEmpleados = formatEmpleados;
                this.isLoadingCalculoTabla = false;
                if(!response.valid){
                    Notify.Error("ADVERTENCIA","Uno o más empleados presentan problemas en el cálculo de su nómina", null, 'Enterado')
                }
                
                
            })
            .catch(err => {
                console.log(err)
                if(typeof err.response.data.error === 'string'){
                    Notify.ErrorToast(err.response.data.error);
                }else{
                    let error = Object.values(err.response.data.error);
                    let leyenda = ``;

                    for (var i = 0; i < error.length; i++) {
                        leyenda+= `* ` + error[i] + `\n`;
                    }

                    Notify.ErrorToast(leyenda);
                }
                this.isSaving = false;
                this.cerrarModalTabla();
            });
        },
        cerrarModalTabla(){
            this.dialogCalculoTabla = false;   
            this.tamModal           = "700px";  
        },
        formatoFecha(fecha) {
            if(fecha == null || fecha == undefined){
                return;
            }
            let fecha2 = fecha.split("-");
            return fecha2[2] + "/" + fecha2[1]+ "/" + fecha2[0];
        },
        /**
         * @method formatNum Esta método parsea un número
         * @description Convierte un número a formato moneda, formato pesos mexicanos 
         * @param {number} num Valor númerico que puede tener números decimales.
         * @return {string} devuelve un string en formato $0.00
        */
        formatNum(num){
            const formatter = new Intl.NumberFormat('es-MX', {
                style: 'currency',
                currency: 'MXN',
            })
            return formatter.format(num);
        },
        redondearNumero(numero){
            return Math.round(numero*100)/100
        },
        async getEmpleados(nominas_id) {
            let param = { 
                nomina_id : nominas_id
            };
            await apiCalculoNomina.getEmpleadosAcumuladoTimbre(param).then(response => {
                this.itemsEmpleadosTabla= response.acumulados;
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los empleados");
                this.detallePrecalculo();
            });
        },
        detallePrecalculo(data){
            this.$session.remove("detallePrecalculoAF");
            this.$router.push('AguinaldoFiniquito');
        },
        netoPago(neto_pagar = 0, indemnizacion = 0){
            return this.formatNum(parseFloat(neto_pagar) + parseFloat(indemnizacion));
        },
    },
    beforeCreate(){
        if(!this.$session.get('detallePrecalculoAF')){
            this.$router.push('Dashboard');
        }
    },
    created() {
        this.nomina = this.$session.get('detallePrecalculoAF');
        this.filters.nomina_id = this.nomina.nomina_id;
        this.urlAvatar = GetUrlImg.getURL();
        this.getEmpleados(this.nomina.nomina_id);
    },

    /**
     * @description updated(). Se ejecuta cada vez que hay un cambio en el Virtual DOM.
    */
    updated() {    
        
        document.querySelector('#tableScrollSimple thead tr th:nth-child(1)').style.width   = "115px";
        /* document.querySelector('#tableScrollSimple thead tr th:nth-child(4)').style.width   = "310px";
        document.querySelector('#tableScrollSimple thead tr th:nth-child(4)').style.paddingRight   = "8px";
        document.querySelector('#tableScrollSimple thead tr th:nth-child(4)').style.paddingLeft   = "8px"; */
    }
}
</script>

<style scoped>
    #padre {
        padding-left: 40%;
    }
    #loading {
        display: table-cell;
        vertical-align: middle;
    }
    .botonModal.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
        display: none;
    }
    .btn-acciones:hover{
        color: #FFFFFF;    
    }
    .tituloAcciones{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.1px;
        color: #1E2245;
    }
    .btn-agrupar-por {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: #1E2245;
        text-transform: none;
        height: 38px !important;
        min-width: 140px !important;
    }
    .menuClassAcciones{
        border-radius: 10px!important;
        margin-top:15px;
    }
    .tablaWidth{
        width: 100%;
        width: -moz-available;          
        width: -webkit-fill-available;  
        width: fill-available;
    }
    #tableScrollSimple tbody{
        max-height:none !important;
        min-width: 100% !important;
        background-color: #fff !important;
    }
    .tbl-child tbody td:first-child {
        padding-left: 35px !important;
        width: 320px;
    }
    .subtitle{
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        color: #828282;
        margin-bottom:0px;
    }
    .text{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 19px;
        color: #828282;
        margin-bottom:0px;
    }
    .textNeto{
        padding-left: 15vh;
    }
</style>